// Non-blocking version-nudge check for `hookmyapp sandbox listen`.
//
// Contract locked by 107-CONTEXT.md §CLI Flow Step 2:
//   - GET https://registry.npmjs.org/@gethookmyapp/cli/latest
//   - 2s hard timeout via AbortSignal.timeout(2000)
//   - If newer, print EXACTLY:
//       "A newer version of hookmyapp is available (<cur> → <new>). Run npm update -g @gethookmyapp/cli"
//   - On ANY failure (network, timeout, non-2xx, malformed JSON): silently return.
//     The nudge is best-effort — it MUST NEVER block listen startup.

// Read package.json version. NOTE: previously we did
//   import { createRequire } from 'node:module';
// which collided with the esbuild banner's createRequire import at bundle
// scope ("Identifier 'createRequire' has already been declared"). Lazy-load
// via a function-scoped dynamic import so neither dev (tsx) nor prod (bundled)
// has a duplicate top-level binding.
async function readCliVersion(): Promise<string> {
  const { createRequire } = await import('node:module');
  const req = createRequire(import.meta.url);
  const pkg = req('../../../package.json') as { version: string };
  return pkg.version;
}

const NPM_REGISTRY_URL = 'https://registry.npmjs.org/@gethookmyapp/cli/latest';
const TIMEOUT_MS = 2000;

export async function checkForNewerCli(): Promise<void> {
  try {
    const res = await fetch(NPM_REGISTRY_URL, { signal: AbortSignal.timeout(TIMEOUT_MS) });
    if (!res.ok) return;
    const body = (await res.json()) as { version?: unknown };
    const latest = body.version;
    if (typeof latest !== 'string' || latest.length === 0) return;
    const current = await readCliVersion();
    if (latest === current) return;
    // Locked one-liner — Plan 09b smoke test asserts the exact prefix.
    console.log(
      `A newer version of hookmyapp is available (${current} → ${latest}). Run npm update -g @gethookmyapp/cli`,
    );
  } catch {
    // Silent by design — network errors, timeouts, parse failures all fall here.
  }
}
